export default __webpack_public_path__ + "static/media/case-study3.cdebe36d.webp";